import LingoFlowWhite from '@/assets/lingoflow_white.svg'
import LingoFlowBlack from '@/assets/lingoflow_black.svg'
import { useTheme } from '@/useTheme.ts'

const LingoFlowIcon = ({ className, invert = false }: { className: string; invert?: boolean }) => {
	const { themeColor } = useTheme()
	if (invert) {
		return themeColor === 'light' ? (
			// @ts-ignore
			<LingoFlowWhite className={className} />
		) : (
			// @ts-ignore
			<LingoFlowBlack className={className} />
		)
	}
	// @ts-ignore
	return themeColor === 'light' ? <LingoFlowBlack className={className} /> : <LingoFlowWhite className={className} />
}

export default LingoFlowIcon
